import { AxiosResponse } from "axios";
import { IAPIResult } from "src/Interfaces/api";

/**
 * Normalize the post-change cart/quote "items" envelope.
 *
 * The backend wrapped the items returned by `GET /quotes/{id}/items`,
 * `GET /cart/items` and `GET /cart/list` from a bare array into
 * `{ trip_start_date, trip_duration, items: [...] }`. Some deployments still
 * return the legacy bare array. This unwraps to the items array so existing
 * consumers — which read `res.data.data` as an array — keep working across both
 * shapes. The trip-shape fields are read elsewhere from the full quote
 * (`GET /quotes/{id}`), so they're intentionally dropped here.
 */
export const normalizeItemsEnvelope = <T>(
    res: AxiosResponse<IAPIResult<T[]>>,
): AxiosResponse<IAPIResult<T[]>> => {
    const body = res?.data;
    const payload = body?.data as unknown;
    if (
        payload &&
        typeof payload === "object" &&
        !Array.isArray(payload) &&
        Array.isArray((payload as { items?: unknown }).items)
    ) {
        return {
            ...res,
            data: { ...body, data: (payload as { items: T[] }).items },
        };
    }
    return res;
};
